import { createFileRoute, Link } from "@tanstack/react-router";
import { ReserveHeader } from "@/components/ReserveHeader";
import { WeeklyGoalTracker } from "@/components/WeeklyGoalTracker";

export const Route = createFileRoute("/_authenticated/bartender/goals")({
  component: GoalsPage,
  head: () => ({
    meta: [
      { title: "Weekly goals · The Hospitality Reserve" },
      { name: "description", content: "Set your weekly earnings and hours targets and track your pace." },
      { name: "robots", content: "noindex" },
    ],
  }),
  errorComponent: () => <div className="p-10 text-center">Could not load goals.</div>,
  notFoundComponent: () => <div className="p-10 text-center">Not found.</div>,
});

function GoalsPage() {
  return (
    <div className="min-h-screen bg-background">
      <ReserveHeader />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10 space-y-6">
        <header className="space-y-2">
          <p className="text-[0.6rem] tracking-wide-luxury uppercase text-muted-foreground">Weekly</p>
          <h1 className="font-display text-3xl">Set your targets</h1>
          <p className="text-sm text-muted-foreground">
            Choose a target for earnings this week — hours and shift count are optional.
            We&apos;ll show your pace and projection on your{" "}
            <Link to="/bartender/recap" className="underline">weekly recap</Link>.
          </p>
        </header>
        <WeeklyGoalTracker />
      </main>
    </div>
  );
}
